module.exports = __webpack_public_path__ + "img/chat_f.89deb748.png";